import { render, staticRenderFns } from "./SetPassword.vue?vue&type=template&id=0b54e9d6&scoped=true"
import script from "./SetPassword.vue?vue&type=script&lang=js"
export * from "./SetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b54e9d6",
  null
  
)

export default component.exports